import React from "react";
import { useFetchTooltipsQuery } from "../../../services/clientfactfind";

const TooltipContext = React.createContext();

export const useTooltipContext = () => {
    return React.useContext(TooltipContext);
}

export const withTooltipProvider = (Component) => (props) => (
    <TooltipProvider>
        <Component {...props} />
    </TooltipProvider>
);

export const TooltipProvider = ({ children }) => {
    const { data, ...fetchResult } = useFetchTooltipsQuery();
    const { isFetching, isError } = fetchResult;

    const getTooltip = (key) => {
        if (isError)
            return "Error.";

        if (isFetching)
            return "Loading...";

        if (data && data[key])
            return data[key];

        return "Unknown.";
    }

    return <TooltipContext.Provider
        value={{
            getTooltip,
            ...fetchResult
        }}
    >
        {children}
    </TooltipContext.Provider>
}

